import React, { useState } from "react";
import { usePermissions } from "../../hooks/usePermissions";
import RoleDashboardTab from "../user/dashRefactor/RoleDashboardTab";
import StaffDashboardTab from "./StaffDashboardTab";

const StaffDashboard: React.FC = () => {
  const { canView } = usePermissions();
  const [activeTab, setActiveTab] = useState("staff");

  const TabContent = () => {
    if (activeTab === "staff") {
      return <StaffDashboardTab />;
    } else if (activeTab === "roles" && canView("Roles")) {
      return <RoleDashboardTab />;
    }
    return null;
  };

  return (
    <div className="min-h-screen py-6 w-full bg-[#F9F9F9] p-4">
      <div className="w-full mx-auto space-y-6">
        <h2 className="text-[20px] font-semibold">All staff</h2>
        <div className="bg-white rounded-[10px] p-2 mt-5 h-[70px] flex items-center overflow-x-auto">
          <nav className="flex px-2 whitespace-nowrap min-w-max">
            <button
              onClick={() => setActiveTab("staff")}
              className={`px-3 py-1 mr-4 font-medium text-[16px] transition-colors ${
                activeTab === "staff"
                  ? "bg-primary/20 text-primary rounded-[8px]"
                  : "border-transparent text-pColor hover:text-hColor"
              }`}
            >
              Staff
            </button>
            {canView("Roles") && (
              <button
                onClick={() => setActiveTab("roles")}
                className={`px-3 py-1 mr-4 font-medium text-[16px] transition-colors ${
                  activeTab === "roles"
                    ? "bg-primary/20 text-primary rounded-[8px]"
                    : "border-transparent text-pColor hover:text-hColor"
                }`}
              >
                Roles
              </button>
            )}
          </nav>
        </div>
        {/* Tab Content */}
        <div className="mt-5">
          <TabContent />
        </div>
      </div>
    </div>
  );
};

export default StaffDashboard;
